import { GetDocumentSignatairesResponse } from "@/app/api/document-signataires/route";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";
import { getDocumentSignatairesRequestSchema } from "@/lib/schemas/document-signataires";

const DOCUMENT_SIGNATAIRES_ENDPOINT = "/api/document-signataires";

export const invalidateDocumentSignatairesQuery = createInvalidateQuery(
  DOCUMENT_SIGNATAIRES_ENDPOINT,
);

export const useDocumentSignatairesQuery =
  createQueryHook<GetDocumentSignatairesResponse>(
    DOCUMENT_SIGNATAIRES_ENDPOINT,
    getDocumentSignatairesRequestSchema,
  );
